<div class="instruction-type">
    <textarea class="shepherd-textarea" #textInput nz-input placeholder="Escribe..." [nzAutosize]="{ minRows: 3, maxRows: 20 }" [(ngModel)]="blockPeriod.text"></textarea>
</div>